"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var http_1 = require("@angular/common/http");
var core_1 = require("@angular/core");
var marked = require("marked");
var operators_1 = require("rxjs/operators");
var marked_options_1 = require("./marked-options");
var MarkdownService = /** @class */ (function () {
    function MarkdownService(http, options) {
        this.http = http;
        this.options = options;
        if (!this.renderer) {
            this.renderer = new marked.Renderer();
        }
    }
    Object.defineProperty(MarkdownService.prototype, "renderer", {
        get: function () { return this.options.renderer; },
        set: function (value) { this.options.renderer = value; },
        enumerable: true,
        configurable: true
    });
    MarkdownService.prototype.compile = function (markdown, markedOptions) {
        if (markedOptions === void 0) { markedOptions = this.options; }
        var precompiled = this.precompile(markdown);
        return marked(precompiled, markedOptions);
    };
    MarkdownService.prototype.getSource = function (src) {
        var _this = this;
        return this.http
            .get(src, { responseType: 'text' })
            .pipe(operators_1.map(function (markdown) { return _this.handleExtension(src, markdown); }));
    };
    MarkdownService.prototype.highlight = function () {
        if (typeof Prism !== 'undefined') {
            Prism.highlightAll(false);
        }
    };
    MarkdownService.prototype.handleExtension = function (src, markdown) {
        var extension = src
            ? src.split('.').splice(-1).join()
            : null;
        return extension !== 'md'
            ? '```' + extension + '\n' + markdown + '\n```'
            : markdown;
    };
    MarkdownService.prototype.precompile = function (markdown) {
        if (!markdown) {
            return '';
        }
        var indentStart;
        return markdown
            .replace(/\&gt;/g, '>')
            .split('\n')
            .map(function (line) {
            // find position of 1st non-whitespace character
            // to determine the markdown indentation start
            if (line.length > 0 && isNaN(indentStart)) {
                indentStart = line.search(/\S|$/);
            }
            // remove whitespaces before indentation start
            return indentStart
                ? line.substring(indentStart)
                : line;
        }).join('\n');
    };
    MarkdownService.decorators = [
        { type: core_1.Injectable },
    ];
    /** @nocollapse */
    MarkdownService.ctorParameters = function () { return [
        { type: http_1.HttpClient, },
        { type: marked_options_1.MarkedOptions, },
    ]; };
    return MarkdownService;
}());
exports.MarkdownService = MarkdownService;
//# sourceMappingURL=markdown.service.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/ngx-markdown/dist/lib/markdown.service.js
// module id = ./node_modules/ngx-markdown/dist/lib/markdown.service.js
// module chunks = vendor